import React from 'react';
import { default as MediaAsset } from '@fiverr-private/cms_ui/src/content_types/MediaAsset/component/MediaAsset';
import { RichText } from '@fiverr-private/cms_ui';

import './styles.scss';

// eslint-disable-next-line react/prop-types
export const BenefitsItem = ({ mediaAsset, content }) => (
    <div className="benefits-item">
        {mediaAsset && <MediaAsset {...mediaAsset} />}
        {content && <RichText {...content} />}
    </div>
);
